import React, {Component} from 'react';
import PropTypes from 'prop-types';
// ---
import Wrapper from '../../components/wrapper';
import './styles.css';
import HeroVideo from '../hero-video';

/**
 * BC03_PhotoInfo - Hero Image/Hero Videoブロック>PhotoInfoに設定するブロック
 * > ※画像を設定する以下ブロックにも利用予定 　Hero Image /Hero Video プレゼンテーション 　スライドギャラリー 　スライドショー 　フォトギャラリー 　360view Picker Full Width プロモ 　オーナーライブラリー　など
 */
export default class PhotoInfo extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.string,
    htmlText: PropTypes.string,
    // extend props.js
    photoInfoWillOpen: PropTypes.func,
    photoInfoWillClose: PropTypes.func,
    inHeroCarousel: PropTypes.bool,
    heroCarouselSlideId: PropTypes.string,
    parentComponentName: PropTypes.string,
    parentComponentId: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    label: null,
    style: null,
    htmlText: null,
    // extend props.js
    photoInfoWillOpen: null,
    photoInfoWillClose: null,
    inHeroCarousel: false,
    heroCarouselSlideId: '',
    parentComponentName: '',
    parentComponentId: '',
  };
  // static getDerivedStateFromProps(props, state) {
  //     // console.log('PhotoInfo.getDerivedStateFromProps', props, state);
  //     if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
  //         return {
  //             isOpen: '',
  //             prevHeroCarouselSlideId: state.heroCarouselSlideId,
  //             heroCarouselSlideId: props.heroCarouselSlideId,
  //         };
  //     }
  //     return null;
  // }
  /**
   * BC03_PhotoInfo 初期処理を行います
   * - button event handler を bind します
   * - state.isOpen 初期値を '' に設定します
   * @param {*} props React.props
   */
  constructor(props) {
    super(props);
    // ---
    /**
     * `photo info` open / close をコントロールする class name
     * - open - ``
     * - close - `is-open`
     * @type {{isOpen: string}}
     */
    this.state = {
      isOpen: '',
      heroCarouselSlideId: '',
    };
    /**
     * open button click event handler - bind onOpen
     * @type {bound|any}
     */
    this.onOpen = this.onOpen.bind(this);
    /**
     * close button click event handler - bind onClose
     * @type {bound|any}
     */
    this.onClose = this.onClose.bind(this);
    //this.close = this.close.bind(this);
    /**
     * info open class - body へ付与します
     * @type {string}
     */
    this.infoOpened = 'PhotoInfo__opened';
    /**
     * bound onCycle
     * @type {bound|any}
     */
    this.onCycle = this.onCycle.bind(this);
    /**
     * requestAnimationFrame id
     * @type {number}
     */
    this.cycleId = 0;
  }
  
  /**
   * ticks
   * - document.body `.PhotoInfo__opened` 有無をチェックします
   * - carousel pager 重なり順問題を解決します
   */
  onCycle() {
    this.cycleId = requestAnimationFrame(this.onCycle);
    const {isOpen} = this.state;
    if (isOpen && !document.body.classList.contains(this.infoOpened)) {
      this.setState({isOpen: ''});
    }
  }
  
  /**
   * open button event handler
   * - state.isOpen - `is-open`
   * @param {Event} event click Event
   */
  onOpen(event) {
    event.preventDefault();
    document.body.classList.add(this.infoOpened);
    this.setState({isOpen: 'is-open'});
    // @since 2018-07-06
    const {photoInfoWillOpen, containerId} = this.props;
    if (typeof photoInfoWillOpen === 'function') {
      photoInfoWillOpen.call(this, containerId);
    }
  }
  
  /**
   * close button click event handler
   * - state.isOpen - ``
   * @param {Event} event click Event
   */
  onClose(event) {
    event.preventDefault();
    this.setState({isOpen: ''});
    document.body.classList.remove(this.infoOpened);
    // @since 2018-07-06
    const {photoInfoWillClose, containerId} = this.props;
    if (typeof photoInfoWillClose === 'function') {
      photoInfoWillClose.call(this, containerId);
    }
  }
  
  /**
   * {@link HeroCarousel} 内 - PhotoInfo open 時に slide 移動したら閉じる
   * @param {*} prevProps previous props
   */
  componentDidUpdate(prevProps) {
    // console.log('PhotoInfo.componentDidUpdate', this.props.parentComponentId, this.state.isOpen, prevProps.heroCarouselSlideId, this.props.heroCarouselSlideId);
    const {inHeroCarousel, heroCarouselSlideId} = this.props;
    if (inHeroCarousel && prevProps.heroCarouselSlideId !== heroCarouselSlideId && this.state.isOpen) {
      // console.log('PhotoInfo.componentDidUpdate --- close ---', this.props.parentComponentId, this.state.isOpen, prevProps.heroCarouselSlideId, this.props.heroCarouselSlideId);
      this.setState({isOpen: ''});
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      document.body.classList.add(this.infoOpened);
      this.setState({isOpen: 'is-open'});
      // @since 2018-07-06
      const {photoInfoWillOpen, containerId} = this.props;
      if (typeof photoInfoWillOpen === 'function') {
        photoInfoWillOpen.call(this, containerId);
      }
    } else {
      this.setState({isOpen: ''});
      document.body.classList.remove(this.infoOpened);
      // @since 2018-07-06
      const {photoInfoWillClose, containerId} = this.props;
      if (typeof photoInfoWillClose === 'function') {
        photoInfoWillClose.call(this, containerId);
      }
    }
  }
  
  // /**
  //  * delegate - will unmount
  //  * - onCycle cancel します
  //  */
  // componentWillUnmount() {
  //     cancelAnimationFrame(this.cycleId);
  // }
  // /**
  //  * delegate - after mount
  //  * - onCycle 稼働し modal open 監視します
  //  */
  // componentDidMount() {
  //     this.onCycle();
  // }
  /**
   * `section.PhotoInfo` Element を作成します
   * - props null check を行います
   * - open / close click event を watch します
   * - color style 設定します
   * @returns {?Element} `section.PhotoInfo`
   */
  render() {
    const {
      containerId,
      containerClass,
      label,
      style,
      htmlText,
    } = this.props;
    // null check
    if (htmlText === null) {
      return null;
    }
    // open class
    const {isOpen} = this.state;
    // color mode - default `Dark`
    const colorStyle = `link__color__${(style || 'Dark').toLowerCase()}`;
    // ---
    // const derivedStateFromProps = HeroVideo.getDerivedStateFromProps(this.props, this.state);
    // output
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <section className={`PhotoInfo ${colorStyle}`}>
          <div className="PhotoInfo__btn__open__wrap">
            {/*<button*/}
              {/*className="PhotoInfo__btn__open"*/}
              {/*type="button"*/}
              {/*onClick={this.onOpen}*/}
            {/*>*/}
            <a
              href="#"
              className="PhotoInfo__btn__open"
              type="button"
              onClick={this.onOpen}
            >
              {label || 'Photo info'}
            </a>
            {/*</button>*/}
          </div>
          <div className={`PhotoInfo__content ${isOpen}`}>
            <div className="PhotoInfo__container">
              <div
                className="PhotoInfo__text Wysiwyg"
                dangerouslySetInnerHTML={{__html: htmlText || ''}}
              />
              <button
                className="PhotoInfo__btn__close"
                type="button"
                onClick={this.onClose}
              />
            </div>
          </div>
        </section>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/photo-info/index.jsx